import { createApp } from 'vue'
import App from './App.vue'
import './styles/demo.css'

createApp(App).mount('#app')

